import React from 'react';
import { arc, pie, scaleLinear } from 'd3';

function PieChart(props) {
  const { x, y, max, min, colors, innerRadius, outerRadius } = props;
  const scale = scaleLinear().domain([min, max]).range([0, 100]);
  const value = scale(props.value);
  var data = [value, 100 - value];
  var arcs = pie().sort(null)(data);
  const arcMaker = arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)

  return (
    <g transform={`translate(${x} ${y})`}>
      {arcs.map((a, i) => (
        <path
          d={arcMaker(a)}
          stroke={colors[i]}
          strokeWidth={1}
          fill={colors[i]}
        />
      ))}
    </g>
  );
}

PieChart.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
  colors: ['green', 'red'], // TODO: Get from theme
  x: 0,
  y: 0,
  innerRadius: 10,
  outerRadius: 20,
  min: 0,
  max: 100,
}

export default PieChart;



// WEBPACK FOOTER //
// ./src/components/PieChart/index.js